import React from "react"
import PropTypes from "prop-types"

import { theme as themeConfig } from "antd"
import { IMG_ERROR, IMG_EMPTY } from "../../../../data/assets"

import SpinnerLoader from "../../../components/SpinnerLoader"
import ShowMessage from "../../../components/ShowMessage"

const CardContainer = ({
  header,
  children,
  container_height,
  loading,
  load_error,
  empty_condition,
  empty_show_message_props,
  error_show_message_props,
  card_container_class,
  style,
}) => {
  const { token } = themeConfig.useToken()

  const renderChildren = () => {
    if (load_error)
      return (
        <div
          className="ori-flex-column"
          style={{ height: `${container_height}px` }}
        >
          {header}
          <ShowMessage
            ImgComponent={IMG_ERROR}
            height={140}
            width={160}
            {...error_show_message_props}
          />
        </div>
      )
    if (empty_condition)
      return (
        <div
          className="ori-flex-column"
          style={{ height: `${container_height}px` }}
        >
          {header}
          <ShowMessage
            ImgComponent={IMG_EMPTY}
            height={140}
            width={160}
            {...empty_show_message_props}
          />
        </div>
      )
    return (
      <>
        {header}
        {children}
      </>
    )
  }

  return (
    <div
      style={{
        paddingLeft: token.paddingSM,
        paddingRight: token.paddingSM,
        paddingBottom: token.padding,
        paddingTop: token.padding,
        marginBottom: token.marginSM,
        backgroundColor: token.colorBgContainer,
        borderRadius: token.borderRadius,
        boxShadow: token.boxShadow,
        ...style,
      }}
      className={`ori-animated ori-fade-in ori-relative ${card_container_class}`}
    >
      {loading && (
        <div
          className="ori-align-full ori-flex-row ori-flex-jc ori-flex-ac"
          style={{
            position: "absolute",
            zIndex: 100,
            opacity: 0.6
          }}
        >
          <SpinnerLoader size="large" text="loading" />
        </div>
      )}
      {renderChildren()}
    </div>
  )
}

CardContainer.propTypes = {
  header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  card_container_class: PropTypes.string,
  loading: PropTypes.bool,
  load_error: PropTypes.bool,
  empty_condition: PropTypes.bool,
  empty_show_message_props: PropTypes.object,
  error_show_message_props: PropTypes.object,
  container_height: PropTypes.number,
  style: PropTypes.object,
}

CardContainer.defaultProps = {
  card_container_class: "",
  loading: false,
  load_error: false,
  container_height: 400,
  empty_show_message_props: {},
  error_show_message_props: {},
  header: null,
  style: {},
}

export default CardContainer
